import { SVGProps } from "react";

const TradeIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16 13.673L19 16.673M19 16.673L16 19.673M19 16.673H5M8 11.673L5 8.67297M5 8.67297L8 5.67297M5 8.67297H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13.673L19 16.673M19 16.673L16 19.673M19 16.673H5M8 11.673L5 8.67297M5 8.67297L8 5.67297M5 8.67297H19"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TradeIcon;
